import { render, staticRenderFns } from "./PeerActivitiesTable.vue?vue&type=template&id=173255b4&scoped=true&"
import script from "./PeerActivitiesTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./PeerActivitiesTable.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173255b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
